// Appelle `callback` une seule fois, au premier passage de `element` dans la zone
// visible, puis arrête d'observer (pas de répétition au scroll). Renvoie une
// fonction d'arrêt (à appeler à la déconnexion du controller), ou null si le
// navigateur n'a pas d'IntersectionObserver : on n'émet alors rien plutôt que
// d'émettre à tort une « section vue » que personne n'a vue.
//
// `rootMargin` négatif en bas : la section doit entrer d'au moins 20 % du viewport,
// sinon un simple effleurement du bord (ou un saut d'ancre) compterait comme lecture.
// `threshold: 0` plutôt qu'un ratio : une section plus haute que l'écran n'atteindrait
// jamais 25 % de surface visible.
export function observeOnce(element, callback, Observer = globalThis.IntersectionObserver) {
  if (!Observer) return null

  let done = false
  const observer = new Observer(entries => {
    if (done || !entries.some(entry => entry.isIntersecting)) return
    done = true
    observer.disconnect()
    callback()
  }, { rootMargin: "0px 0px -20% 0px" })
  observer.observe(element)

  return () => observer.disconnect()
}
